import type * as SentryNext from '@sentry/nextjs';

type SentrySdk = typeof SentryNext;

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

export const sentryEnabled =
  process.env.NODE_ENV === 'production' &&
  Boolean(dsn && dsn.startsWith('https://'));

let sdk: SentrySdk | null = null;
let sdkPromise: Promise<SentrySdk> | null = null;

export function loadSentry(): Promise<SentrySdk> | null {
  if (!sentryEnabled) return null;
  if (!sdkPromise) {
    sdkPromise = import('@sentry/nextjs').then((Sentry) => {
      Sentry.init({
        dsn,
        environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'development',
        tracesSampleRate: 0,
        ignoreErrors: [
          'AbortError',
          'TypeError: Failed to fetch',
          'TypeError: NetworkError when attempting to fetch a resource.',
          'TypeError: Load failed'
        ]
      });
      sdk = Sentry;
      return Sentry;
    });
  }
  return sdkPromise;
}

export function getLoadedSentry(): SentrySdk | null {
  return sdk;
}

export function captureExceptionLazy(error: unknown): void {
  loadSentry()?.then((Sentry) => Sentry.captureException(error));
}
